import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      console.log(error, errorInfo);
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <div><h1 style={{textAlign:"center"}}>Data not available.</h1>
            <p style={{textAlign:"center", color:"red"}}>Please refresh the page and try again</p>
          </div>;
      }
  
      return this.props.children; 
    }
  }


  export default ErrorBoundary;